import { Bell, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface NotificationPermissionPromptProps {
  onAllow: () => void;
  onDismiss: () => void;
}

export function NotificationPermissionPrompt({ onAllow, onDismiss }: NotificationPermissionPromptProps) {
  return (
    <div className="fixed bottom-20 left-4 right-4 z-40 md:left-auto md:right-4 md:w-96 animate-in slide-in-from-bottom">
      <Card className="border-primary shadow-lg">
        <CardHeader className="relative pb-3">
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-2 top-2 h-6 w-6"
            onClick={onDismiss}
          >
            <X className="h-4 w-4" />
          </Button>
          <div className="flex items-center gap-2">
            <Bell className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">Stay Updated</CardTitle>
          </div>
          <CardDescription>
            Enable notifications to track your orders and get exclusive deals
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="space-y-2 text-sm">
            <div className="flex items-start gap-2">
              <span className="text-success">✓</span>
              <span>Real-time order tracking updates</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-success">✓</span>
              <span>Early access to flash sales</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-success">✓</span>
              <span>Personalized product recommendations</span>
            </div>
          </div>
          <div className="flex gap-2">
            <Button onClick={onAllow} className="flex-1">
              Enable Notifications
            </Button>
            <Button variant="outline" onClick={onDismiss}>
              Not Now
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
